import React, {
  createContext,
  useContext,
  type PropsWithChildren,
} from 'react';

export type WidgetRefreshValue = {
  refresh: () => void;
  refreshing: boolean;
};

const WidgetRefreshContext = createContext<WidgetRefreshValue | null>(null);

/** Lets nested widgets pick up the page-level refresh without prop drilling. */
export function WidgetRefreshScope({
  refresh,
  refreshing,
  children,
}: PropsWithChildren<WidgetRefreshValue>) {
  return (
    <WidgetRefreshContext.Provider value={{ refresh, refreshing }}>
      {children}
    </WidgetRefreshContext.Provider>
  );
}

export function useWidgetRefresh(): WidgetRefreshValue | null {
  return useContext(WidgetRefreshContext);
}
